import { render, staticRenderFns } from "./SalesHistory.vue?vue&type=template&id=afc8400c&scoped=true&"
import script from "./SalesHistory.vue?vue&type=script&lang=js&"
export * from "./SalesHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afc8400c",
  null
  
)

export default component.exports